import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import styles from "./AddressInput.scss";
import { ThemeContext } from "../Theme";
import { Dropdown } from "../Dropdown";
import { Input } from "../Input";
import { validate, validationType } from "../../helper/validation";

class AddressInputInner extends React.Component {
  static propTypes = {
    countries: PropTypes.arrayOf(PropTypes.string).isRequired,
    forwardedRef: PropTypes.func,
  };

  static defaultProps = {
    forwardedRef: null,
  };

  static contextType = ThemeContext;

  constructor(props) {
    super(props);
    this.state = {
      isValidPostalCode: undefined,
      isValidCity: undefined,
      isValidStreetName: undefined,
      isValidHouseNumber: undefined,
    };
  }

  validatePostalCode = (e) => {
    e.target.value = e.target.value.trim();
    const input = e.target.value;
    if (input !== "") {
      this.setState({
        isValidPostalCode: validate(validationType.postalCode, input),
      });
    } else {
      this.setState({ isValidPostalCode: undefined });
    }
  };

  validateCity = (e) => {
    e.target.value = e.target.value.trim().split(/\s+/).join(" ");
    const input = e.target.value;
    if (input !== "") {
      this.setState({
        isValidCity: validate(validationType.streetCity, input),
      });
    } else {
      this.setState({ isValidCity: undefined });
    }
  };

  validateStreetName = (e) => {
    e.target.value = e.target.value.trim().split(/\s+/).join(" ");
    const input = e.target.value;
    if (input !== "") {
      this.setState({
        isValidStreetName: validate(validationType.streetCity, input),
      });
    } else {
      this.setState({ isValidStreetName: undefined });
    }
  };

  validateHouseNumber = (e) => {
    e.target.value = e.target.value.trim();
    const input = e.target.value;
    if (input !== "") {
      this.setState({
        isValidHouseNumber: validate(validationType.houseNumber, input),
      });
    } else {
      this.setState({ isValidHouseNumber: undefined });
    }
  };

  render() {
    const { countries, forwardedRef, ...restProps } = this.props;
    const {
      isValidPostalCode,
      isValidCity,
      isValidStreetName,
      isValidHouseNumber,
    } = this.state;

    return (
      <div ref={forwardedRef} className={styles.wrapper} {...restProps}>
        <div className={styles.row}>
          <div className={styles.col24}>
            <Dropdown label="Land*" items={countries} />
          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.secondCol}>
            <Input
              isValid={isValidPostalCode}
              onBlur={this.validatePostalCode}
              invalidMessage="Die Postleitzahl ist ungültig."
            >
              PLZ*
            </Input>
          </div>
          <div className={styles.thirdCol}>
            <Input
              isValid={isValidCity}
              onBlur={this.validateCity}
              invalidMessage="Der Ort ist ungültig."
            >
              Ort*
            </Input>
          </div>
        </div>

        <div className={styles.row}>
          <div className={styles.fourthCol}>
            <Input
              isValid={isValidStreetName}
              onBlur={this.validateStreetName}
              invalidMessage="Die Straße ist ungültig."
            >
              Straße
            </Input>
          </div>
          <div className={styles.fifthCol}>
            <Input
              isValid={isValidHouseNumber}
              onBlur={this.validateHouseNumber}
              invalidMessage="Die Nummer ist ungültig."
            >
              Nr.*
            </Input>
          </div>
        </div>
      </div>
    );
  }
}

export const AddressInput = forwardRef((props, ref) => (
  <AddressInputInner forwardedRef={ref} {...props} />
));
AddressInput.displayName = "AddressInput";

export default AddressInput;
